<template>
  <portal to="popup">
    <div :class="[$style.wrapper, className, opened && $style.opened, charHidden && $style.hidden]">
      <div :class="$style.char"></div>
      <div :class="[$style.box, boxClass]">
        <slot />
        <div :class="$style.button" v-if="button">
          <v-btn @click="handleButtonClick">{{button}}</v-btn>
        </div>
      </div>
    </div>
  </portal>
</template>
<script>
export default {
  name: 'helpBox',
  props: {
    button: {
      type: String,
      default: null,
    },
    autoClose: {
      type: Boolean,
      default: true,
    },
    className: {
      type: String,
      default: null,
    },
    boxClass: {
      type: String,
      default: null,
    },
    charHidden: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    opened: false,
  }),
  methods: {
    open() {
      this.opened = true
    },
    close() {
      this.opened = false
    },
    handleButtonClick() {
      this.close()
      this.$emit('click')
    },
  },
}
</script>
<style lang="scss" module src="./helpBox.scss"></style>
